import Vue from 'vue'
import Swal from 'sweetalert2/src/sweetalert2.js';

import 'sweetalert2/dist/sweetalert2.min.css';

const alertConfig = {}

const toastConfig = {
  position: 'top-end',
  toast: true,
  timer: 2000,
  showConfirmButton: false,
}

const Alert = {}

async function fire(opts, alertOption) {
  let config = {...alertOption}
  if(typeof opts === 'string') {
    config = { ...alertOption, title: opts };
  } else if (typeof opts === 'object') {
    config = { ...alertOption, ...opts };
  }
  return await Swal.fire({ ...config })
}

Alert.install = function (Vue) {
  Vue.prototype.$alert = async function (opts) {
    let alertOption = {
      ...alertConfig
    }
    return await fire(opts, alertOption);
  };
  
  Vue.prototype.$alert.success = async function (opts) {
    let alertOption = {
      icon: 'success',
      ...alertConfig
    }
    return await fire(opts, alertOption);
  };
  Vue.prototype.$alert.error = async function (opts) {
    let alertOption = {
      icon: 'error',
      ...alertConfig
    }
    return await fire(opts, alertOption);
  };
  Vue.prototype.$alert.confirm = async function (opts) {
    let alertOption = {
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      ...alertConfig
    }
    return await fire(opts, alertOption);
  };

  Vue.prototype.$toast = async function (opts) {
    let toastOption = {
      ...toastConfig
    }
    return await fire(opts, toastOption);
  };
  Vue.prototype.$toast.success = async function (opts) {
    const toastOption = {
      icon: 'success',
      ...toastConfig
    }
    return await fire(opts, toastOption);
  };
  Vue.prototype.$toast.error = async function (opts) {
    const toastOption = {
      icon: 'error',
      ...toastConfig
    }
    return await fire(opts, toastOption);
  };

  Vue.prototype.$successResponse = async function (response, type = 'toast', message) {
    if(!message) {
      message = "Successful Executed!";
      if(response.data && response.data.message) {
        message = response.data.message;
      }
    }
    let options = {
      icon: 'success',
    }

    if(type === 'toast') {
      options = {
        ...options,
        ...toastConfig
      }
    }
    return await fire(message, options);
  }

  Vue.prototype.$errorResponse = async function (error, type = 'toast', message) {
    if(!message) {
      message = error.message;
      if(error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
    }

    let options = {
      icon: 'error',
      timer: 5000
    }

    if(type === 'toast') {
      options = {
        ...toastConfig,
        ...options
      }
    }
    
    return await fire(message, options);
  }
}

export default Alert;
Vue.use(Alert);
